import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
// import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import {
    MuiThemeProvider,
    createMuiTheme,
    withStyles,
} from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import PasswordResetForm from '../password/PasswordResetForm'
import ChangePasswordForm from '../password/ChangePasswordForm'


import { Notification, translate, userLogin, email, TextInput, required, minLength, maxLength } from 'react-admin';

import { lightTheme } from './themes';

import {
    sendCodeVal, setCode,
} from '../password/passwordActions'

import { ErrorWrapper } from '../common/ErrorWrapper'
import { SelectInput } from 'react-admin';
import { CardHeader, Checkbox, Typography } from '@material-ui/core';
import { getUserURL } from '../api';
import { COUNTRY_LIST } from '../constants/countries';

const styles = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    heading: {
        marginTop: '1em',
        marginBottom: '1em',
        width: '100%',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
    },
    headline: {
        marginBottom: '0.5em',
        fontWeight: 'bold',
    },
    spacer: {
        flex: 1,
    },
    card: {
        width: '100%',
        maxWidth: 500,
        marginTop: '6em',
        padding: '2em',
    },
    avatar: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        backgroundColor: theme.palette.secondary.main,
    },
    hint: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
        color: theme.palette.grey[500],
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        marginTop: '1em',
    },
    actions: {
        padding: '0 1em 1em 1em',
    },
});

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
    meta: { touched, error } = {},
    input: { ...inputProps },
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
);

const activatedButtonVriant = 'raised'
// const inactivatedButtonVriant = 'flat'


const validateName = [required(), minLength(2), maxLength(30)];
const validateEmail = [required(), email()];
const validateOptionalEmail = [email()]; // 可选的邮箱验证，不是必填

class Login extends Component {

    renderHeader = () => {
        const { classes } = this.props;
        return (
            <div className={classes.heading}>

                <img src='/logos/loko_home_logo_100.png' width="160px" alt="loko logo" />
                <span className={classes.spacer} />
            </div>
        )
    }

    getParameterByName = (name, url) => {
        if (!url) url = window.location.href;
        console.log(url)
        name = name.replace(/[[]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        console.log(results)
        if (!results) return null;
        console.log(results[2])
        if (!results[2]) return '';
        console.log(decodeURIComponent(results[2].replace(/\+/g, " ")))
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    componentDidMount() {
        // 监听URL变化，如果有formName参数则切换表单
        const formName = this.getParameterByName('formName');
        const referralEmail = this.getParameterByName('referralEmail');
        
        const newState = {};
        
        if (formName && this.state.forms.includes(formName)) {
            newState.activatedForm = formName;
        }
        
        // 如果URL中有referralEmail参数，更新state并设置表单初始值
        if (referralEmail) {
            newState.referralEmail = referralEmail;
        }
        
        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    }

    componentDidUpdate(prevProps) {
        // 当location发生变化时，检查formName和referralEmail参数
        if (this.props.location !== prevProps.location) {
            const formName = this.getParameterByName('formName');
            const referralEmail = this.getParameterByName('referralEmail');
            
            const newState = {};
            
            if (formName && this.state.forms.includes(formName) && formName !== this.state.activatedForm) {
                newState.activatedForm = formName;
            }
            
            // 如果URL中的referralEmail参数发生变化，更新state
            if (referralEmail !== this.state.referralEmail) {
                newState.referralEmail = referralEmail || '';
            }
            
            if (Object.keys(newState).length > 0) {
                this.setState(newState);
            }
        }
    }

    state = {
        forms: ['signin', 'signup', 'password-reset'],
        activatedForm: this.getParameterByName('formName') || 'signin',
        passwordResetCode: this.getParameterByName('passwordResetCode'),
        referralEmail: this.getParameterByName('referralEmail') || '', // 获取URL中的referralEmail参数
        termsChecked: false,
        errorMessage: '',
        verificationCode: '',
        sendingCode: false,
        codeSent: false,
        countdown: 0,
    }

    sendVerificationCode = () => {
        const { formValues } = this.props;
        const email = formValues && formValues.email;
        if (!email) {
            this.setState({ errorMessage: 'Please enter your email first' });
            return;
        }

        this.setState({ sendingCode: true, errorMessage: '' });
        const baseUrl = getUserURL();
        
        fetch(`${baseUrl}/v1/common/send-verification-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email_phone: email,
                verification_type: 'register'
            }),
        })
        .then(res => res.json())
        .then(response => {
            if (response.code && response.code !== 200) {
                this.setState({
                    errorMessage: response.message || 'Failed to send verification code',
                    sendingCode: false,
                });
            } else {
                this.setState({
                    codeSent: true,
                    sendingCode: false,
                    countdown: 60,
                });
                // 开始倒计时
                this.startCountdown();
            }
        })
        .catch(error => {
            this.setState({
                errorMessage: 'Failed to send verification code',
                sendingCode: false,
            });
        });
    }

    startCountdown = () => {
        const timer = setInterval(() => {
            this.setState(prevState => {
                if (prevState.countdown <= 1) {
                    clearInterval(timer);
                    return { countdown: 0, codeSent: false };
                }
                return { countdown: prevState.countdown - 1 };
            });
        }, 1000);
    }

    login = auth => {
        this.setState({
            errorMessage: '',
        });
        if (this.state.activatedForm === 'signup') {
            // 添加验证码字段
            const signupData = {
                ...auth,
                verification_code: this.state.verificationCode
            };
            
            const baseUrl = getUserURL();
            fetch(`${baseUrl}/v1/user/signup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(signupData),
            }).then(res => res.json()).then(response => {
                if (Object.prototype.hasOwnProperty.call(response, 'code')) {
                    /* {
                       "code": 10003,
                       "message": "An acount with that email already exits"
                   } */
                    console.error(response.message);
                    this.setState({
                        errorMessage: response.message,
                    });
                } else {
                    /* {
                         "active": true,
                         "country": "USA",
                         "dateOfBirth": "",
                         "email": "xujx@bitfa.vip",
                         "firstName": "",
                         "id": "ff136d14-ab9e-4128-974e-55fe6956e983",
                         "lastName": "",
                         "locations": null,
                         "name": "xujx",
                         "phoneNumber": "",
                         "registerStep": 1,
                         "userType": "store_owner"
                     } */
                    // 注册成功后，先清除URL中的所有参数，然后跳转到根路径
                    this.clearAllURLParameters();
                    this.props.userLogin(
                        {
                            email: auth.email,
                            password: auth.password,
                        },
                        '/' // 直接跳转到根路径，不保留任何参数
                    );
                }
            })

        } else if (this.state.activatedForm === 'signin') {
            this.props.userLogin(
                auth,
                this.props.location.state
                    ? this.props.location.state.nextPathname
                    : '/'
            );
        }


    }

    handleSwitch = (event) => {
        event.preventDefault()
        switch (this.state.activatedForm) {
            case 'signin':
                this.setState({
                    activatedForm: 'signup'
                }, () => {
                    // 更新URL参数
                    this.updateURLParameter('formName', 'signup');
                })
                break;
            case 'signup':
                this.setState({
                    activatedForm: 'signin'
                }, () => {
                    // 更新URL参数
                    this.updateURLParameter('formName', 'signin');
                })
                break;
            default:
                this.setState({
                    activatedForm: 'signin'
                }, () => {
                    // 更新URL参数
                    this.updateURLParameter('formName', 'signin');
                })
                break;
        }
    }

    updateURLParameter = (param, value) => {
        const url = new URL(window.location);
        if (value) {
            url.searchParams.set(param, value);
        } else {
            url.searchParams.delete(param);
        }
        window.history.replaceState({}, '', url);
    }

    // 清理所有URL参数的方法
    clearAllURLParameters = () => {
        const url = new URL(window.location);
        url.search = ''; // 清除所有查询参数
        window.history.replaceState({}, '', url);
    }

    resetView = () => {
        this.setState({
            activatedForm: 'signin'
        });
        this.updateURLParameter('formName', 'signin');
    }

    renderSigninForm = () => {
        const { handleSubmit, translate, classes, isLoading } = this.props
        return (
            <form onSubmit={handleSubmit(this.login)}>
                <div className={classes.form}>
                    <Typography variant='headline' className={classes.headline}>
                        Sign in
                    </Typography>
                    <div className={classes.input}>
                        <Field
                            autoFocus
                            name="email"
                            validate={validateEmail}
                            component={renderInput}
                            // label={translate('ra.validation.email')}
                            label="Email"

                            disabled={isLoading}
                        />
                    </div>
                    <div className={classes.input}>
                        <PasswordInput label={translate('ra.auth.password')} name="password" validate={required()} source="password" />
                        {/* <Field
                            name="password"
                            component={renderInput}
                            label={translate('ra.auth.password')}
                            type="password"
                            disabled={isLoading}
                        /> */}
                    </div>
                </div>
                <CardActions className={classes.actions}>
                    <Button
                        name="signin"
                        variant={activatedButtonVriant}
                        type="submit"
                        color="primary"
                        disabled={isLoading}
                        className={classes.button}
                        fullWidth
                    >
                        {isLoading && (
                            <CircularProgress size={25} thickness={2} />
                        )}
                        Submit
                        {/* {translate('ra.auth.sign_in')} */}
                    </Button>
                </CardActions>
                <div>
                    <Button
                        style={{
                            float: 'left',
                            marginLeft: '0.5em',
                        }}
                        color='primary'
                        size="small"
                        className={classes.forgotPassword}
                        onClick={() => {
                            this.setState({
                                activatedForm: 'password-reset'
                            });
                            this.updateURLParameter('formName', 'password-reset');
                        }}
                    >
                        forgot password?
                    </Button>

                    <Button
                        style={{
                            float: 'right',
                            marginRight: '0.5em',
                        }}
                        color='primary'
                        size="small"
                        className={classes.signup}
                        onClick={() => {
                            this.setState({
                                activatedForm: 'signup'
                            });
                            this.updateURLParameter('formName', 'signup');
                        }}
                    >
                        {translate('ra.auth.sign_up')}
                    </Button>

                </div>
            </form>
        )
    }

    renderPasswordResetForm = () => {
        // const { handleSubmit, translate, classes, isLoading } = this.props
        return <PasswordResetForm resetView={this.resetView} />;
    }

    checkAllTerms = (selected) => {

        this.setState({
            termsChecked: selected
        })

    }

    renderSignupForm = () => {
        const { handleSubmit, translate, classes, isLoading } = this.props;
        return (
            <form onSubmit={handleSubmit(this.login)}>
                <div className={classes.form}>
                    <Typography variant='headline' className={classes.headline}>
                        Let's create your account
                    </Typography>
                    <Typography variant='body1' >
                        Signing up for Loko is fast and free - no commitment or long-term contracts.
                    </Typography>
                    <div className={classes.input}>
                        <Field
                            autoFocus
                            name="name"
                            validate={validateName}
                            component={renderInput}
                            // label={translate('ra.validation.email')}
                            label="Username"

                            disabled={isLoading}
                        />
                    </div>
                    <div className={classes.input}>
                        <Field
                            autoFocus
                            name="email"
                            validate={validateEmail}
                            component={renderInput}
                            label="Email"
                            disabled={isLoading}
                        />
                    </div>
                    <div className={classes.input} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                        <TextField
                            style={{ flex: 1 }}
                            label="Verification Code"
                            value={this.state.verificationCode}
                            onChange={(e) => this.setState({ verificationCode: e.target.value })}
                            disabled={isLoading}
                            fullWidth
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={this.sendVerificationCode}
                            disabled={isLoading || this.state.sendingCode || this.state.countdown > 0}
                            style={{ marginTop: '9px', minWidth: '120px', height: '40px' }}
                        >
                            {this.state.sendingCode ? (
                                <CircularProgress size={20} />
                            ) : this.state.countdown > 0 ? (
                                `${this.state.countdown}s`
                            ) : (
                                'Send Code'
                            )}
                        </Button>
                    </div>
                    <div className={classes.input}>
                        <PasswordInput
                            label={translate('ra.auth.password')}
                            name="password"
                            validate={required()}
                            source="password" />
                    </div>
                    <div className={classes.input}>
                        <SelectInput
                            style={{
                                width: '100%',
                            }}
                            label="Country"
                            name="country"
                            source="country"
                            choices={COUNTRY_LIST} />
                    </div>
                    <div className={classes.input}>
                        <Field
                            name="referralEmail"
                            validate={validateOptionalEmail}
                            component={renderInput}
                            label="Referral Email (Optional)"
                            disabled={isLoading}
                        />
                    </div>
                    <div className={classes.form}>
                        <Typography variant='body1' color='error' >{this.state.errorMessage}</Typography>
                    </div>
                    <div className={classes.input}>
                        <Checkbox
                            color='primary'
                            onChange={(e) => this.checkAllTerms(e.target.checked)}                     
                        />
                        <span style={{ color: 'grey', fontSize: '0.9em' }}>
                            I agree to Loko's <a href="/terms.html" target="_blank">Terms</a> and <a href="/privacy.html" target="_blank">Privacy Policy</a>.
                        </span>
                    </div>
                </div>
                <CardActions className={classes.actions}>
                    <Button
                        name="signin"
                        variant={activatedButtonVriant}
                        type="submit"
                        color="primary"
                        disabled={isLoading || this.state.termsChecked === false || !this.state.verificationCode}
                        className={classes.button}
                        fullWidth
                    >
                        {isLoading && (
                            <CircularProgress size={25} thickness={2} />
                        )}
                        {translate('ra.auth.sign_up')}
                    </Button>
                </CardActions>

                <div className={classes.form}>
                    <Typography variant='body1' >
                        Already have a Loko account ?
                        <Button
                            color='primary'
                            size="small"
                            className={classes.signup}
                            onClick={() => {
                                this.setState({
                                    activatedForm: 'signin'
                                });
                                this.updateURLParameter('formName', 'signin');
                            }}
                        >
                            {translate('ra.auth.sign_in')}
                        </Button>
                    </Typography>

                </div>
            </form>
        )
    }

    formSwitcher = (formName) => {

        const { sendCodeVal, setCode, isVal, valErr } = this.props
        if (this.state.passwordResetCode) {
            console.log(this.state.passwordResetCode)
            console.log("set Code")
            setCode(this.state.passwordResetCode)
            sendCodeVal(this.state.passwordResetCode)
        }

        if (isVal) {
            return <ChangePasswordForm code={this.state.passwordResetCode} resetView={this.resetView} />
        }

        if (valErr) {
            return (
                <ErrorWrapper>{valErr}</ErrorWrapper>
            )
        }

        switch (formName) {
            case 'signup':
                return this.renderSignupForm()
            case 'password-reset':
                return this.renderPasswordResetForm()
            default:
                return this.renderSigninForm()
        }
    }

    render() {
        const { classes } = this.props; //handleSubmit, isLoading, translate
        return (

            <div className={classes.main}>
                <div>
                    {this.renderHeader()}
                </div>

                <Card className={classes.card}>
                    {this.formSwitcher(this.state.activatedForm)}
                </Card>
                <Notification />
            </div>
        );
    }
}

Login.propTypes = {
    ...propTypes,
    authProvider: PropTypes.func,
    classes: PropTypes.object,
    previousRoute: PropTypes.string,
    translate: PropTypes.func.isRequired,
    userLogin: PropTypes.func.isRequired,
    userSignup: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    isLoading: state.admin.loading > 0,
    isVal: state.password.isVal,
    valErr: state.password.valErr,
    formValues: getFormValues('signIn')(state),
});

const enhance = compose(
    translate,
    reduxForm({
        form: 'signIn',
        enableReinitialize: true, // 允许重新初始化表单
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            if (!values.email) {
                errors.username = translate('ra.validation.required');
            }
            if (!values.password) {
                errors.password = translate('ra.validation.required');
            }
            return errors;
        },
    }),
    connect(
        mapStateToProps,
        { userLogin, sendCodeVal, setCode },
    ),
    withStyles(styles)
);

const EnhancedLogin = enhance(Login);

// We need to put the MuiThemeProvider decoration in another component
// Because otherwise the withStyles() HOC used in EnhancedLogin won't get
// the right theme
class LoginWithTheme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialValues: this.getInitialValues()
        };
    }

    componentDidMount() {
        // 监听URL变化
        window.addEventListener('popstate', this.handleURLChange);
    }

    componentWillUnmount() {
        // 清理事件监听器
        window.removeEventListener('popstate', this.handleURLChange);
    }

    componentDidUpdate(prevProps) {
        // 如果location发生变化，更新initialValues
        if (this.props.location !== prevProps.location) {
            this.handleURLChange();
        }
    }

    handleURLChange = () => {
        const newInitialValues = this.getInitialValues();
        this.setState({ initialValues: newInitialValues });
    }

    // 获取URL参数中的referralEmail
    getParameterByName = (name, url) => {
        if (!url) url = window.location.href;
        name = name.replace(/[[]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    getInitialValues = () => {
        const referralEmail = this.getParameterByName('referralEmail') || ''; // 修改参数名为referralEmail
        return {
            referralEmail: referralEmail
        };
    }

    render() {
        return (
            <MuiThemeProvider theme={createMuiTheme(lightTheme)}>
                <EnhancedLogin {...this.props} initialValues={this.state.initialValues} />
            </MuiThemeProvider>
        );
    }
}

class PasswordInput extends React.Component {
    state = {
        showPassword: false,
    };

    togglePasswordVisibility = () => {
        this.setState((prevState) => ({
            showPassword: !prevState.showPassword,
        }));
    };

    render() {
        const { label, source, ...props } = this.props;
        const { showPassword } = this.state;

        return (
            <div style={{
                position: "relative"
            }}>
                <TextInput
                    style={{
                        width: '100%',
                    }}
                    label={label}
                    source={source}
                    type={showPassword ? 'text' : 'password'}
                    {...props}
                />
                <Button
                    style={{
                        position: 'absolute',
                        top: "28px",
                        right: "0px"
                    }}
                    variant="text"
                    onClick={this.togglePasswordVisibility}
                    edge="end"
                    aria-label={showPassword ? 'Hide Password' : 'Show Password'}
                >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                </Button>
            </div>
        );
    }

}

export default LoginWithTheme;
